import React, { Component } from 'react';
import { CircleCheckBig } from 'lucide-react';
import { APP_CONST } from '../../../../../../constants';
import { GeckoFields, GeckoBtn, Spinner } from '../../../../../../components';

export class ConfirmCode extends Component {
    state= {
        mfaCode: '',
        showManualEntry: false,
    }

    renderQr() {
        if (this.props.qrUrl) {
            return (
                <img src={this.props.qrUrl} width="200" height="200"/>
            )
        }

        return (
            <Spinner />
        );
    }

    renderConfirmationField() {

        return (
            <div className="mfaConfirmationFieldContainer flex flex-col gap-4 mt-4">
                <GeckoFields 
                    fields={this.fields()}
                    values={this.state}
                    handler={this.handleChange.bind(this)}
                    submitHandler={() => {}} 
                />

                <GeckoBtn 
                    name={'Verify'}
                    icon={CircleCheckBig}
                    type={APP_CONST.BTN_TYPE_PRIMARY}
                    className={'confirmMfaButton self-start'}
                    handler={() => this.props.confirmCode(this.state.mfaCode)}
                />
            </div>
        );
    }

    handleChange(name, evt) {
        this.setState({[name]: evt});
    }

    fields()
    {
        return [{
            label: 'MFA Code',
            key: 'mfaCode',
            width: '100%',
            disabledWhen: () => false,
            type: APP_CONST.FIELD_TYPE_TEXT,
        }];
    }

    revealSecretCode() {
        this.setState({
            showManualEntry: true,
        })
    }

    renderManualEntryCode(visible = false, code) {
        if (!code) {
            return null;
        }

        if (!visible) {
            return (
                <div className="manual2faInstructions">
                    <a id="triggerManualEntry" className="text-foreground text-sm underline hover:text-muted-foreground" onClick={() => this.revealSecretCode()}>Or enter secret code manually</a>
                </div>
            )
        }

        return (
            <div className="manual2faInstructions">
                <span className="font-medium text-sm text-foreground block">Manually enter secret code:</span>
                <code className="secretCode font-mono text-xs text-red-700 bg-slate-100 px-1.5 py-1.5 rounded border border-border whitespace-nowrap overflow-x-auto max-w-full">{code}</code>
            </div>
        )
    }

    render() {
        return (
            <div>
                <div className="qrCodeContainer">
                    <p className="text-sm font-medium text-foreground">1. Launch your authenticator app and scan the QR code</p>

                    {this.renderQr()}

                    {this.renderManualEntryCode(this.state.showManualEntry, this.props.secretCode)}

                    <p className="text-sm font-medium text-foreground mt-4">2. Confirm it works by entering the number from your authenticator app</p>
                </div>

                {this.renderConfirmationField()}
            </div>
        )
    }

}

ConfirmCode.defaultProps = {
    qrUrl: null,
    secretCode: null,
    confirmCode: () => null,
}

export default ConfirmCode;